export function getLogo(company: { logo?: Array<{ link_o: string }>; external_logo?: string }): string | undefined {
    return company.logo?.[0]?.link_o ?? company.external_logo;
}

export function getBackground(company: { background?: Array<{ link_o: string }> }): string | undefined {
    return company.background?.[0]?.link_o;
}

export function getTopBackground(company: { top_background?: Array<{ link_o: string }> }): string | undefined {
    return company.top_background?.[0]?.link_o;
}
